module.exports = __webpack_public_path__ + "img/interior-gallery-3.b1d6f021.jpg";